import { RefreshCw } from 'lucide-react'

import { Button } from '../ui/button'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select'

export interface BatchOption {
  id: number
  batchNumber: string
  expirationDate: string
  physical: number
}

interface BatchOptionSelectProps {
  options: BatchOption[]
  value?: number | string
  onChange: (batchId: number | undefined) => void
  loading?: boolean
  error?: boolean
  onRetry?: () => void
  disabled?: boolean
  placeholder?: string
  emptyHint?: string
  ariaLabel?: string
}

export function BatchOptionSelect({
  options,
  value,
  onChange,
  loading = false,
  error = false,
  onRetry,
  disabled = false,
  placeholder = 'Selecciona un lote vigente',
  emptyHint,
  ariaLabel = 'Seleccionar lote existente',
}: BatchOptionSelectProps) {
  const selectedValue = value && options.some((option) => option.id === Number(value))
    ? String(value)
    : ''

  if (error) {
    return (
      <div className="flex items-center justify-between gap-3 rounded-md border border-red-200 bg-red-50 p-2 text-sm text-red-700">
        <span>No fue posible cargar los lotes.</span>
        {onRetry && (
          <Button type="button" size="sm" variant="outline" onClick={onRetry}>
            <RefreshCw className="mr-2 h-4 w-4" />Reintentar
          </Button>
        )}
      </div>
    )
  }

  return (
    <div className="space-y-1">
      <Select
        value={selectedValue}
        onValueChange={(next) => onChange(Number(next))}
        disabled={disabled || loading || options.length === 0}
      >
        <SelectTrigger className="bg-white" aria-label={ariaLabel}>
          <SelectValue placeholder={loading ? 'Cargando lotes...' : options.length === 0 ? 'No hay lotes vigentes' : placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.id} value={String(option.id)}>
              {option.batchNumber} · {option.expirationDate} · físico {option.physical}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {!loading && options.length === 0 && emptyHint && (
        <p className="text-xs text-amber-700">{emptyHint}</p>
      )}
    </div>
  )
}
